import { integrationActionTypes } from '../../actions/integrations/integrationsActions';

const IntegrationReducers = (state = { }, action) => {
  switch (action.type) {
  case integrationActionTypes.GET_INTEGRATIONS.LOADING: {
    const { getIntegrationsLoading } = action;
    return {
      ...state,
      getIntegrationsLoading,
    };
  }
  case integrationActionTypes.GET_INTEGRATIONS.SUCCESS: {
    const { integrations } = action;
    return {
      ...state,
      integrations,
    };
  }

  default: {
    return state;
  }
  }
};

export default IntegrationReducers;
